import React, { Key } from 'react';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';

import { EPCheckbox } from '@/comp';
import { EPSelect, EPSelectOption } from '@/components';
import ValueDashboard from '@/assets/icon-value-dashboard.svg?react';

interface ValueDashboardReportRowProps {
  field: {
    name: string | number;
    fieldKey?: Key;
  };
  isFormDisabled: boolean;
  isValueDashboardChecked: boolean;
  isDisableValueDashboardReport: boolean;
  onTimeChange: () => void;
}

const ValueDashboardReportRow: React.FC<ValueDashboardReportRowProps> = ({
  field,
  isFormDisabled,
  isValueDashboardChecked,
  isDisableValueDashboardReport,
  onTimeChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="notification-settings-row-container">
      <div className="severity-container">
        <ValueDashboard style={{ height: '17px', width: '17px' }} />
        <span className="label">{t('valueDashboard')}</span>
      </div>
      <div className="notification-description-container">{t('Notifies when a Report is generated')}</div>
      <div className="notification-preference-container">
        <div style={{ display: 'flex', gap: 5 }}>
          <Form.Item
            {...field}
            name={[field.name, 'subscriptions', 'ValueDashboardReport', 'email']}
            key={[field.fieldKey, 'subscriptions.ValueDashboardReport.email'] as unknown as Key}
            valuePropName={'checked'}
          >
            <EPCheckbox onChange={onTimeChange} disabled={isFormDisabled || isDisableValueDashboardReport}>
              {t('Email')}
            </EPCheckbox>
          </Form.Item>
          <Form.Item
            {...field}
            name={[field.name, 'subscriptions', 'ValueDashboardReport', 'status']}
            key={[field.fieldKey, 'subscriptions.ValueDashboardReport.status'] as unknown as Key}
          >
            <EPSelect
              disabled={isValueDashboardChecked || isDisableValueDashboardReport}
              defaultValue="ValueDashboardWeekly"
              size="small"
            >
              <EPSelectOption value="ValueDashboardWeekly">{t('Weekly')}</EPSelectOption>
              <EPSelectOption value="ValueDashboardReportMonthly">{t('Monthly')}</EPSelectOption>
            </EPSelect>
          </Form.Item>
        </div>
      </div>
    </div>
  );
};

export default ValueDashboardReportRow;
